import React from 'react';
import { Button, RadioGroup, Typography } from '@telus-uds/components-web';
import { Formik, Form, Field } from 'formik';
import FieldLocationInput from '../form/fields/fieldLocationInput';
import { getStepTwoSchema } from './schema';
import { useTranslationsContext } from '../context/TranslationsContext';
import ErrorIcon from '../../assets/images/icon_error_messages.gif';
import { channelFields } from '../utils/index';

const StepTwo = ({
  onSubmit,
  stepData: {
    serviceAddress,
    isMultiSuite,
    businessType,
    propertyRoom,
    noOfEmployees
  },
  role
}) => {
  const translations = useTranslationsContext();
  const pageKey = "businessInformation";

  const {
    REFERRALS: {
      stepTwo: { labels, errorLabels }
    }
  } = translations;
  const [yes, no] = labels.IsMultiSuiteOptions;
  const [hotel, multiDewelingUnits, seniorLiving] = labels.businessTypeOptions;
  const [oneToFifteen, sixToTwenty, twentyOnePlus] = labels.propertyRoomOptions;
  const [
    oneToThirty,
    thirtyToHundred,
    hundredPlus
    // oneToTen,
    // elevenToTwentyNine,
    // thirtyToFourtyNine,
    // fiftyPlus,
  ] = labels.noOfEmployeesOptions;
  const handleOnChangeNoValueMultiSuite = (values) => {
    // clear businessType & propertyRoom values if isMultiSuite = No
    values.businessType = ""
    values.propertyRoom = ""
  }

  return (
    <div className='layout-container'>
    <Formik
      validationSchema={getStepTwoSchema(errorLabels, isMultiSuite)}
      validateOnBlur={false}
      validateOnChange={false}
      onSubmit={onSubmit}
      initialValues={{
        serviceAddress: serviceAddress || '',
        isMultiSuite: (!channelFields(pageKey) ? no : ''),
        businessType: businessType || '',
        propertyRoom: propertyRoom || '',
        noOfEmployees: noOfEmployees || ''
      }}
    >
      {({ errors, touched, values, setFieldValue, handleChange, handleSubmit }) => (
        <Form>
          <div className="main-content-form-headers" style={{ marginTop: 20 }}>
            <Typography block heading="h4" variant={{ size: 'h4' }}>{labels.serviceAddress}*</Typography>
          </div>
          <div
            style={{ position: 'relative' }}
            className={`input-container ${errors.serviceAddress && touched.serviceAddress ? 'error' : ''
              }`}
          >
            <FieldLocationInput
              data={{
                name: 'serviceAddress',
                type: 'Address',
                maxLength: 100,
                minLength: 10,
                value: values.serviceAddress,
                onChange: handleChange,
                readonly: false,
                disabled: false,
                isSameAs: false
              }}
            />
            <>
              <div className="error_messages">
                <Typography>
                  {errors.serviceAddress}
                </Typography>
              </div>
              <div id="username_error_icon" className="error_messages_icon">
                <img src={ErrorIcon} alt="error_icon" />
              </div>
            </>
          </div>
          {channelFields(pageKey) && (
            <div style={{ marginBottom: '20px' }}>
              <RadioGroup
                legend={`${labels.isMultiSuite}*`}
                items={[
                  { label: yes, id: 'Yes' },
                  { label: no, id: 'No' }
                ]}
                checkedId={values.isMultiSuite || null}
                onChange={(value) => {
                  setFieldValue('isMultiSuite', value);
                  if (value === 'No') {
                    setFieldValue('businessType', '');
                    setFieldValue('propertyRoom', '');
                  }
                }}
                name="isMultiSuite"
                validation={errors.isMultiSuite && touched.isMultiSuite ? 'error' : undefined}
                feedback={errors.isMultiSuite && touched.isMultiSuite ? errors.isMultiSuite : undefined}
              />
            </div>
          )}
          {values.isMultiSuite === 'Yes' && (
            <div style={{ marginBottom: '20px' }}>
              <RadioGroup
                legend={`${labels.businessType}*`}
                items={[
                  { label: hotel, id: hotel },
                  { label: multiDewelingUnits, id: multiDewelingUnits },
                  { label: seniorLiving, id: seniorLiving }
                ]}
                checkedId={values.businessType || null}
                onChange={(value) => setFieldValue('businessType', value)}
                name="businessType"
                validation={errors.businessType && touched.businessType ? 'error' : undefined}
                feedback={errors.businessType && touched.businessType ? errors.businessType : undefined}
              />
            </div>
          )}
          {values.isMultiSuite === 'Yes' && values.businessType && (!channelFields(pageKey)) && (
            <div style={{ marginBottom: '20px' }}>
              <RadioGroup
                legend={labels.propertyRoom}
                items={[
                  { label: oneToFifteen, id: oneToFifteen },
                  { label: sixToTwenty, id: sixToTwenty },
                  { label: twentyOnePlus, id: twentyOnePlus }
                ]}
                checkedId={values.propertyRoom || null}
                onChange={(value) => setFieldValue('propertyRoom', value)}
                name="propertyRoom"
                validation={errors.propertyRoom && touched.propertyRoom ? 'error' : undefined}
                feedback={errors.propertyRoom && touched.propertyRoom ? errors.propertyRoom : undefined}
              />
            </div>
          )}
          {!channelFields(pageKey) && (
            <div style={{ marginBottom: '20px' }}>
              <RadioGroup
                legend={labels.noOfEmployees}
                items={[
                  { label: oneToThirty, id: oneToThirty },
                  { label: thirtyToHundred, id: thirtyToHundred },
                  { label: hundredPlus, id: hundredPlus }
                ]}
                checkedId={values.noOfEmployees || null}
                onChange={(value) => setFieldValue('noOfEmployees', value)}
                name="noOfEmployees"
                validation={errors.noOfEmployees && touched.noOfEmployees ? 'error' : undefined}
                feedback={errors.noOfEmployees && touched.noOfEmployees ? errors.noOfEmployees : undefined}
              />
            </div>
          )}
          <div style={{ marginTop: '40px' }}>
            <Button
              variant={{ priority: 'high' }}
              type="button"
              onClick={handleSubmit}
              id="referrals"
            >
              Next
            </Button>
          </div>
        </Form>
      )}
    </Formik>
    </div>
  );
};

export default StepTwo;
